//@flow

import React, { Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';
import type { FormikProps } from 'formik';
import { connect as formikConnect } from 'formik';

import { roundOff } from '../../lib/utils';

type Props = {
  formik: FormikProps,
  totalPrice: number,
};

const PriceWithPromoCode = ({ formik, totalPrice }: Props) => {
  const discountPrice =
    !isEmpty(formik) && formik.values.discount
      ? roundOff(Number(formik.values.discount) * totalPrice, 2)
      : 0;
  const finalPrice = totalPrice - discountPrice;

  return (
    <Fragment>
      {discountPrice ? (
        <Fragment>
          <Price title="Actual Price" price={totalPrice} />
          <Price title="Discount" price={discountPrice} />
        </Fragment>
      ) : null}
      <Price title="Total Price" price={finalPrice} />
    </Fragment>
  );
};

const Price = ({ title, price }: { title: string, price: number }) => (
  <div className="total-price">
    <div style={{ color: '#000' }}>{title}</div>
    <div className="price">USD {price.toLocaleString()}</div>
  </div>
);

export default formikConnect(PriceWithPromoCode);



// WEBPACK FOOTER //
// ./src/components/PromoCode/PriceWithPromoCode.jsx